<template>
  <div class="container-fluid px-0 mx-auto">
    <div class="row align-items-center">
      <div class="col-md-4">
        <fieldset class="border p-2 px-2 rounded" style="height:70vh;">
          <legend class="text-left w-auto"><i class="fa fa-file-image-o"></i> Logotipo</legend>
          <div class="row align-items-center h-100 py-4">
            <div class="col-md-12 text-center">
              <div @click="changePhoto" class="image-container w-75 mx-auto" :class="{ 'uploading': loading }">
                <img id="logo" :src="emp_logo" width="100%" />
                <my-upload :field="'upload'" @crop-success="cropSuccess" @crop-upload-success="cropUploadSuccess"
                  @crop-upload-fail="cropUploadFail" v-model="show" :noRotate="false" langType="pt-br" :width="250"
                  :height="55" :url="apiUrl" :params="params" :headers="headers" img-format="png">
                </my-upload>
              </div>
              <small>
                <required /> Tamanho sugerido: 250x55px</small>
            </div>
            <div class="col-md-12">
              <div class="callout bg-light m-0">
                <p><strong><i class="fa fa-info-circle"></i> Dica: <i
                      class="fa fa-file-image-o pull-right"></i></strong>
                </p>
                <p>Clique na imagem ao lado e selecione um o logo de seu computador.</p>
                <small>O Logotipo será utilizado nos e-mails enviados.</small>
              </div>
            </div>
          </div>
        </fieldset>
      </div>
      <div class="col-md-4">
        <fieldset class="border p-2 rounded" style="height:70vh;">
          <legend class="text-left w-auto"><i class="fa fa-paint-brush"></i> Cor do Fundo</legend>
          <div class="row align-items-center h-100 justify-content-center">
            <div class="col-md-12">
              <p class="m-0 pb-4">Selecione a cor do cabeçalho do E-mail:
                <span class="mx-2 alert position-relative">
                  <span class="position-absolute rounded-circle" :style="`backgroundColor: ${colorSelect}`"> </span>
                </span>
              </p>
              <sketch-picker :class="'mx-auto'" :value="colorSelect" @input="updateValue"
                :preset-colors="presetColor" />
            </div>
          </div>
        </fieldset>
      </div>
      <div class="col-md-4">
        <fieldset class="border p-2 rounded" style="height:70vh;">
          <legend class="text-left w-auto"><i class="fa fa-paint-brush"></i> Pré-visualização</legend>
          <div class="row align-items-center h-100">
            <div class="col-md-12">
              <div class="w3-card pt-3 px-3 mx-auto">
                <p class="xxSmall">Ass.:Assinador DocXDigital</p>
                <p class="xxSmall">de:contato@docxdigital.com.br</p>
                <p class="xxSmall">para:receive@email.com</p>
                <div class="pt-3 px-3 text-center">
                  <div class="my-1 m-0 py-1 cors" :style="`backgroundColor: ${colorSelect}`">
                    <img id="logoPrev" :src="emp_logo" width="60%" alt="">
                  </div>
                  <div class="my-1 m-0 linhas mx-3 bg-gray"></div>
                  <div class="my-1 m-0 linhas mx-3 bg-gray"></div>
                  <div class="my-1 m-0 linhas mx-4 bg-gray"></div>
                  <div class="my-1 m-0 linhas mx-4 bg-gray"></div>
                  <div class="my-1 m-0 linhas mx-5 bg-warning"></div>
                  <div class="my-1 m-0 linhas mx-4 bg-gray"></div>
                  <div class="my-1 m-0 linhas mx-4 bg-gray"></div>
                  <div class="my-1 m-0 linhas mx-3 bg-gray"></div>
                  <div class="my-1 m-0 linhas mx-4 bg-gray"></div>
                  <div class="my-1 m-0 linhas mx-3 bg-gray"></div>
                  <div class="my-1 m-0 linhas mx-3 bg-gray"></div>
                  <div class="my-1 m-0 linhas mx-4 bg-gray"></div>
                  <div class="my-1 m-0 linhas mx-4 bg-gray"></div>
                  <div class="my-1 m-0 linhas mx-5 bg-warning"></div>
                  <div class="my-1 m-0 linhas mx-4 bg-gray"></div>
                  <div class="my-1 m-0 linhas mx-4 bg-gray"></div>
                  <div class="my-1 m-0 linhas mx-3 bg-gray"></div>
                  <div class="my-1 m-0 linhas mx-4 bg-gray"></div>
                </div>
                <p class="xxSmall pb-2 my-2 text-right">docxdigital.com.br</p>
              </div>
            </div>
          </div>
        </fieldset>
      </div>
    </div>
  </div>
</template>

<script>
  import Cookies from 'js-cookie';
  import myUpload from 'vue-image-crop-upload';
  import {
    Sketch
  } from 'vue-color'
  export default {
    components: {
      myUpload,
      sketchPicker: Sketch,
    },
    data() {
      return {
        loading: true,
        emp_logo: '',
        show: false,
        imgDataUrl: null,
        colorSelect: '#000',
        presetColor: ['transparent', '#FFFFFF', '#009432FF', '#27AE60FF', '#A3CB38FF', '#2C3E50FF', '#0652DDFF',
          '#12CBC4FF', '#8E44ADFF', '#F39C12FF', '#D35400FF', '#EA2027FF', '#C0392BFF', '#BDC3C7FF', '#7F8C8DFF',
          '#000000FF'
        ],
        headers: {
          'Authorization': 'Bearer ' + Cookies.get('access_token')
        },
        img: null,
        params: {},
        apiUrl: `${process.env.VUE_APP_BASE_URL}/api/empresa/logo`
      }
    },
    watch: {
      $route(now) {
        if (now.name == 'parametros') this.loadData();
      }
    },
    beforeMount() {
      this.loadData();
    },
    computed: {
      theme() {
        let cor = '';
        switch (this.appLayout.theme) {
          case 'primary':
            cor = '#007bff';
            break;
          case 'secondary':
            cor = '#6c757d';
            break;
          case 'purple':
            cor = '#6f42c1';
            break;
          case 'success':
            cor = '#28a745';
            break;
          case 'danger':
            cor = '#dc3545';
            break;
          case 'warning':
            cor = '#ffc107';
            break;
        }
        return cor;
      },
    },
    methods: {
      loadData() {
        this.$store.dispatch('getParametros').then(response => {
          this.emp_logo = response.logo_64 || require('@/assets/you-logo.png');
          this.colorSelect = response.cor || this.theme;
        }).catch(e => {
          toastr({
            title: 'Erro ao processar',
            icon: 'error'
          })
        }).finally(() => {
          this.loading = false;
        })
      },
      cropSuccess(imgDataUrl, field) {
        this.emp_logo = imgDataUrl;
      },
      cropUploadSuccess(jsonData, field) {},
      cropUploadFail(status, field) {
        toastr({
          icon: 'error',
          title: 'Erro ao atualizar a logo.'
        });
        this.emp_logo = require('@/assets/you-logo.png');
        this.show = false;
      },
      changePhoto() {
        this.show = true;
      },
      updateValue(payload) {
        this.colorSelect = payload.hex8;
        this.save();
      },
      save() {
        this.loading = true;
        let params = {
          logo: 'unknow',
          logo_64: this.emp_logo,
          cor: this.colorSelect,
        }
        this.$store.dispatch('setParametros', params).then(response => {
          toastr({
            title: response.message,
            icon: response.status
          })
        }).catch(e => {
          let message = '';
          e.map(e => message += `${e}\n`)
          toastr({
            title: message,
            icon: 'error'
          })
        }).finally(() => {
          this.loading = false;
        })
      }
    }
  }
</script>

<style scoped>
  .alert {
    background-color: lightgray;
  }

  .position-absolute {
    width: 25px;
    height: 25px;
    left: 20%;
    right: 20%;
  }

  .w3-card {
    width: 250px;
    height: 300px;
    box-shadow: 0 2px 5px 0 rgb(0 0 0 / 16%), 0 2px 10px 0 rgb(0 0 0 / 12%);
  }

  .xxSmall {
    font-size: x-small;
    line-height: 1;
    margin: 0;
  }

  .linhas {
    height: 5px;
  }

  .cors {
    height: auto;
  }
</style>
<style lang="scss" scoped>
  .image-container {
    height: auto;
    position: relative;
    overflow: hidden;
    border: 1px solid #777;
    cursor: pointer;

    .vue-image-crop-upload {
      cursor: default;
    }

    input {
      cursor: pointer;
      height: auto;
      opacity: 0;
    }

    img {
      border: 3px solid #fff;
    }

    &::after {
      font-family: FontAwesome;
      line-height: 120%;
      font-size: 3.2rem;
      content: "\f03e";
      color: #fff;
      text-align: center;
      display: block;
      position: absolute;
      z-index: 1;
      top: 0;
      width: 100%;
      height: 100%;
      border: 1px solid #fff;
      background-color: rgba(0, 0, 0, 0.4);
      opacity: 0;
    }

    &:not(.uploading):hover::after {
      opacity: 1;
    }

    @keyframes fa-spin {
      0% {}

      100% {
        -webkit-transform: rotate(359deg);
      }
    }
  }
</style>